module.exports = __webpack_public_path__ + "img/adimg3.383b49f6.png";